"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getViewPermissions", {
  enumerable: true,
  get: function get() {
    return _getPermissions["default"];
  }
});
var _getPermissions = _interopRequireDefault(require("./getPermissions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }